module.exports = __webpack_public_path__ + "static/media/video_course.6c33a805.png";